
<div class="min-vh-100">
  <app-candidat-header></app-candidat-header>
  <div class="candidat-container">
    <router-outlet></router-outlet>

  </div>
</div>
